module.exports = __webpack_public_path__ + "static/media/send-pending.7022f2d2.svg";